<template>
    <b-card no-body>
        <!-- <UpdateStatusModal :update_status.sync="modals.update_status" v-on:closeModal="closeModal()" :status_data="status_data" /> -->
        <UpdateChannelModal :update_channel.sync="modals.update_channel" v-on:closeModal="closeModal()" :channel_data="channel_data" @getChannel="getChannel()" />
        <!-- HEADER -->
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>
    
        <!-- SEARCH INPUT -->
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                    label="Search"
                    v-model="searchQuery"
                    v-on:input="debouncedHandler"
                    prepend-icon="fas fa-search"
                    placeholder="Search..."
                    >
                    </base-input>
                </b-col>
            </b-row>
        </b-col>
        <!-- TABLE LIST -->
        <div class="table-listings">
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"

                :data="queriedData"
                style="width: 100%;"
                @selection-change="selectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    fixed="left"
                    height="500"
                ></el-table-column>
    
                <!-- CHANNEL NAME COLUMN -->
                <el-table-column
                    prop="name"
                    label="Channel Name"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">{{ scope.row.name }}</p>
                        <!-- <router-link :to="'/mainStatus'" class="name font-weight-500 mb-0">
                        </router-link> -->
                    </template>
                </el-table-column>
                
                <!-- HUB COLUMN -->
                <!-- <el-table-column
                prop="hub_id"
                label="Hub"
								v-if="checkRoleType(['admin'])  && checkAppCode('sas')"
								>
                <template slot-scope="scope">
                    <p class="mb-0 top-line">{{ scope.row.hub_name }}</p>
                </template>
                </el-table-column> -->

                <!-- CHANNEL CREATED BY COLUMN -->
                <el-table-column
                    prop="created_by"
                    label="Created By">
                </el-table-column>

                <!-- CHANNEL CREATED AT COLUMN -->
                <el-table-column
                    prop="created_at"
                    label="Date Created"
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.created_at">
                            {{ scope.row.created_at | dateFormatString }}
                        </div>
                    </template>
                    
                </el-table-column>

                <!-- CHANNEL ACTIONS COLUMN -->
                <el-table-column
                    width="55"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-dropdown :tabindex="scope.row.id" class="py-2">
                            <b class="el-dropdown-link">
                                <b-icon icon="three-dots-vertical">
                                </b-icon>
                            </b>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="editChannel(scope.row)">
                                    Edit
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="deleteChannel(scope.row.channel_id)">
                                    Delete
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>

                </el-table-column>

            </el-table>
        </div>

        <!-- FOOTER -->
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>

    </b-card>
</template>

<script>
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
// import { EventBus } from '../../../main'
import { EventBus } from '@/main'

import UpdateChannelModal from './Modals/UpdateChannelModal.vue'

import {
    notifyFunctionMixin,
		helperFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'



export default {
    name: 'source-channel-table',
    mixins: [notifyFunctionMixin,clientPaginationMixin,helperFunctionMixin],
    components: {
        BasePagination,
        UpdateChannelModal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
    },
    data() {
        return {
            modals: {
                update_channel: false,
            },
            isTableLoading: true,
            propsToSearch:['name'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [],
            channel_data: {},
        }
    },
    created(){
        this.getChannel()
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);

        EventBus.$on('getAllChannel', this.getChannel)
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
        getChannel(){
            this.isTableLoading = true
            axios.get(services.lookup + 'channel', {headers: getHeader()})
            .then(res => {
                this.tableData = res.data.data
                this.isTableLoading = false
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        editChannel(channel){
            this.channel_data = channel
            this.modals.update_channel = true;
        },
        closeModal(){
            this.modals.update_channel = false
        },
        deleteChannel(channel_id){
            swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(services.lookup + 'channel/' + channel_id, {headers: getHeader()})
                    .then(res => {
                            this.getChannel()
                            this.notifySuccess('<b>Status: </b> - Successfully Deleted.')
                            return 
                        })
                        .catch(e => {
                            this.isTableLoading = false
                            this.errorFunction(e)
                        })
                }
            })
        }
    }
}
</script>